import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MeasureService } from 'src/app/services/measure.service';
import { NotificationManager } from '../notification-manager';

enum EExoticType {
    EAU,
    MASSIF,
    LINGETTE
}

@Component({
    selector: 'exotic-creation-box',
    templateUrl: 'exotic-creation-box.html',
    styleUrls: ['./exotic-creation-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExoticCreationDialog implements OnInit {

    private interventionCode: string;
    public ExoticTypeList: string[] = Object.values(EExoticType)
        .filter(x => isNaN(Number(x)))
        .map((x: any) => x);
    Count: number = 1;
    SelectedType: EExoticType = EExoticType.LINGETTE;

    constructor(
        private snackbar: MatSnackBar,
        private measureService: MeasureService,
        public dialogRef: MatDialogRef<ExoticCreationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.interventionCode = data;
    }

    ngOnInit() {
    }


    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        let callback;
        switch (this.SelectedType) {
            case EExoticType.EAU:
                callback = this.measureService.addEau(this.interventionCode, this.Count);
                break;
            case EExoticType.LINGETTE:
                callback = this.measureService.addLingette(this.interventionCode, this.Count);
                break;
            case EExoticType.MASSIF:
                callback = this.measureService.addMassif(this.interventionCode, this.Count);
                break;
        }
        callback.subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Mesure ajoutées', this.snackbar);
                this.dialogRef.close(x);
            }
        })
    }
}
